import React from "react";
import Chips from "../../Chips";
import SlBet from "../../SlBet";

import { IProps } from "./m22MultiTable";
import { getWinClassName, betGroupProp } from "@/modules/commonMobile";
import { checkPlayerBankerTie } from "@/modules/games/Baccarat";

export default class M22Portrait extends React.Component<IProps> {
    render() {
        const { basePcode, win, checkTieWin, tieBetTypes, totalCards, pairs, langdata, completeTable } = this.props;
        
        const gwcn = getWinClassName;

		const commonBetProps = {
			pcode: this.props.pcode,
			chipBase: this.props.chipBase,
			mobile: this.props.mobile,
			bets: this.props.bets,
			insertBet: this.props.insertBet,
			langStr: langdata.language_code
		};

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const portraitRows = [
			[
				["col-xs-6", "playerpair", "playerpair", pairs.player, langdata["txt_player_pair"], "11:1"],
				["col-xs-6", "bankerpair", "bankerpair", pairs.banker, langdata["txt_banker_pair"], "11:1"]
			],
			[
				["col-40p taller", "player", "player",
					win && (win.playerValue > win.bankerValue),
					<div className="baccarat-blue-text" key="m22_slbet_player">{langdata["txt_player"]}</div>,
					"1:1"
				],
				["col-20p taller", "tie", "tie",
					checkTieWin,
					<div className="baccarat-green-text" key="m22_slbet_tie">{langdata["txt_tie"]}</div>,
					"8:1"
				],
				["col-40p taller", "banker", "banker",
					win && (win.playerValue < win.bankerValue),
					<div className="baccarat-red-text" key="m22_slbet_banker">{langdata["txt_banker"]}</div>,
					"0.95:1"
				]
			]
		];

        return (
            completeTable ? (
                <div className="sl-table m22 full_v3">
                    {
                        portraitRows.map((row, rowIdx) =>
                            <div className="row" key={"m22_slbet_" + rowIdx}>
                            {
                                row.map((cell, cellIdx) =>
                                    <SlBet {...commonBetProps}
                                        key={"m22_slbet_" + rowIdx + "_" + cellIdx}
                                        classes={"sl-bet " + cell[0] + " sl-baccarat-bet-blue"}
                                    
                                        bet={cell[1] as string}
                                        group={cell[2] as string}
                                    
                                        winStatement={cell[3] as boolean}
                                    
                                        betLabel={cell[4] as JSX.Element}
                                        betType={cell[5] as string}

                                        betOutOfBounds={this.props.betOutOfBounds}
                                    
                                        noTooltip={true}
                                    />
                                )
                            }
                            </div>
                        )
                    }
                    
                    <div className="row">
                        <div className={"sl-bet col-xs-6 sl-baccarat-bet-blue" + gwcn(win && totalCards === 4)}
                            {...betGroupProp(this, "small", "small")}
                            // bet="small" pcode={this.props.pcode} group="small"
                            onClick={this.props.insertBet}>
                            {langdata["txt_small"]}
                            <div className="bet-type">1.5:1</div>
                            <Chips {...commonChipProps} betKey="small+small" />
                        </div>
                        <div className={"sl-bet col-xs-6 sl-baccarat-bet-blue" + gwcn(win && totalCards > 4)}
                            {...betGroupProp(this, "big", "big")}
                            // bet="big" pcode={this.props.pcode} group="big"
                            onClick={this.props.insertBet}>
                            {langdata["txt_big"]}
                            <div className="bet-type">0.54:1</div>
                            <Chips {...commonChipProps} betKey="big+big" />
                        </div>
                    </div>
        
                    <div className="row">
                        <div className={"sl-bet col-xs-6 sl-baccarat-bet-blue" + gwcn(pairs.either)}
                            {...betGroupProp(this, "eitherpair", "eitherpair")}
                            // bet="eitherpair" pcode={this.props.pcode} group="eitherpair"
                            onClick={this.props.insertBet}>
                            {langdata["txt_either_pair"]}
                            <div className="bet-type">5:1</div>
                            <Chips {...commonChipProps} betKey="eitherpair+eitherpair" />
                        </div>
                        <div className={"sl-bet col-xs-6 sl-baccarat-bet-blue" + gwcn(pairs.perfect)}
                            {...betGroupProp(this, "perfectpair", "perfectpair")}
                            // bet="perfectpair" pcode={this.props.pcode} group="perfectpair"
                            onClick={this.props.insertBet}>
                            {langdata["txt_perfect_pair"]}
                            <div className="bet-type">25:1</div>
                            <Chips {...commonChipProps} betKey="perfectpair+perfectpair" />
                        </div>
                    </div>
        
                    <div className="row">
                        {langdata["txt_tie_on"]}
                    </div>
                    
                    <div className="row">
                    {
                        // tie9
                        [0, 1, 2, 3, 4].map(item => 
                            <div key={"por_comp_tie_" + item}
                                    className={"sl-bet col-20p square sl-baccarat-bet-blue" + gwcn(checkPlayerBankerTie(win, item))}

                                    {...betGroupProp(this, `tie${item}`, `tie${item}`)}

                                    onClick={this.props.insertBet}>
                                { item }
                                <div className="bet-type">{tieBetTypes[item]}</div>
                                <Chips {...commonChipProps} betKey={`tie${item}+tie${item}`} />
                            </div>
                        )
                    }
                    </div>
        
                    <div className="row">
                    {
                        [5, 6, 7, 8, 9].map(item => 
                            <div key={"por_comp_tie_" + item}
                                    className={"sl-bet col-20p square sl-baccarat-bet-blue" + gwcn(checkPlayerBankerTie(win, item))}

                                    {...betGroupProp(this, `tie${item}`, `tie${item}`)}

                                    onClick={this.props.insertBet}>
                                { item }
                                <div className="bet-type">{tieBetTypes[item]}</div>
                                <Chips {...commonChipProps} betKey={`tie${item}+tie${item}`} />
                            </div>
                        )
                    }
                    </div>
                </div>
            ) : (
                <div className="sl-table m22 simpler">
                    <div className="row">
                        <div className={"sl-bet col-xs-6 sl-baccarat-bet-blue" + gwcn(pairs.player)}
                            {...betGroupProp(this, "playerpair", "playerpair")}
                            onClick={this.props.insertBet}>
                            <div>{ langdata["txt_player_pair"] }</div>
                            <div className="bet-type">11:1</div>
                            <Chips {...commonChipProps} betKey="playerpair+playerpair" />
                        </div>
        
                        <div className={"sl-bet col-xs-6 sl-baccarat-bet-blue" + gwcn(pairs.banker)}
                            {...betGroupProp(this, "bankerpair", "bankerpair")}
                            onClick={this.props.insertBet}>
                            <div>{ langdata["txt_banker_pair"] }</div>
                            <div className="bet-type">11:1</div>
                            <Chips {...commonChipProps} betKey="bankerpair+bankerpair" />
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className={"sl-bet col-40p taller sl-baccarat-bet-blue" + gwcn(win && (win.playerValue > win.bankerValue))}
                            {...betGroupProp(this, "player", "player")}
                            onClick={this.props.insertBet}>
                            <div className="baccarat-blue-text">{langdata["txt_player"]}</div>
                            <div className="bet-type">
                            {
                                basePcode === "m28" ?
                                "0.97:1" :
                                "1:1"
                            }
                            </div>
                            <Chips {...commonChipProps} betKey="player+player" />
                        </div>
        
                        <div className={"sl-bet col-20p taller sl-baccarat-bet-blue" + gwcn(checkTieWin)}
                            {...betGroupProp(this, "tie", "tie")}
                            onClick={this.props.insertBet}>
                            <div className="baccarat-green-text">{langdata["txt_tie"]}</div>
                            <div className="bet-type">8:1</div>
                            <Chips {...commonChipProps} betKey="tie+tie" />
                        </div>

                        <div className={"sl-bet col-40p taller sl-baccarat-bet-blue" + gwcn(win && (win.playerValue < win.bankerValue))}
                            {...betGroupProp(this, "banker", "banker")}
                            onClick={this.props.insertBet}>
                            <div className="baccarat-red-text">{ langdata["txt_banker"] }</div>
                            <div className="bet-type">
                            {
                                basePcode === "m28" ?
                                "0.97:1" :
                                "0.95:1"
                            }
                            </div>
                            <Chips {...commonChipProps} betKey="banker+banker" />
                        </div>
                    </div>					
                </div>					
            )
        );
    }    
}